import { useMemo } from "react";
import { useLiveFlags } from "../hooks/useLiveFlags";
import { parseSystemMaintenance } from "../utils/systemMaintenance";
import { SystemMaintenancePage } from "./SystemMaintenancePage";
import { UserNotice } from "./UserNotice";

/**
 * Owns the single live-flag poller and the two things it drives:
 *
 * - `system_maintenance` enabled: the whole app is replaced by
 *   SystemMaintenancePage. Mounted in Providers, outside every page, so
 *   there is no route that renders anything else and client-side navigation
 *   just re-renders the same page. Open sessions switch within one poll.
 * - otherwise: the page, plus the `user_notice` overlay.
 */
export const MaintenanceGate = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const flags = useLiveFlags();
  const maintenance = useMemo(
    () =>
      flags?.system_maintenance.enabled
        ? parseSystemMaintenance(flags.system_maintenance.value)
        : null,
    [flags]
  );

  if (maintenance) {
    return <SystemMaintenancePage endDateTime={maintenance.endDateTime} />;
  }

  return (
    <>
      {children}
      <UserNotice flag={flags?.user_notice ?? null} />
    </>
  );
};
